import UserScreen from './index';

const routes = [
  {
    path: '/user',
    component: UserScreen,
  },
];

export default routes;
